import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, OnDestroy, PLATFORM_ID } from '@angular/core';
import { doc, docData, Firestore } from '@angular/fire/firestore';
import { traceUntilFirst } from '@angular/fire/performance';
import { Subscription } from 'rxjs';

import { DataService } from './data.service';
import { Settings } from '../models/settings.model';
import { TermsAndConditionsService } from './terms-and-conditions.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends DataService<Settings> implements OnDestroy {
  private settingsSubscription?: Subscription;

  constructor(
    private firestore: Firestore,
    private termsAndConditionsService: TermsAndConditionsService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    super();
  }

  public init(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (this.settingsSubscription && !this.settingsSubscription.closed) {
      return;
    }

    const ref = doc(this.firestore, 'settings/current');

    this.settingsSubscription = docData(ref).pipe(
      traceUntilFirst('firestore')
    ).subscribe({
      next: (res: any) => {
        if (res) {
          const settings = res as Settings;
          this.set(settings);

          if (settings.termsAndConditions && settings.termsAndConditionsDate) {
            this.termsAndConditionsService.load(settings.termsAndConditions, settings.termsAndConditionsDate)
          }
        }
      },
      error: (error) => {
        console.warn('[SettingsService] settings/current listener failed:', error);
        this.settingsSubscription = undefined;
      },
    });

    this.addSubscription(this.settingsSubscription);
  }
}
